// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper--glFSr","Contained":"Contained--Zc0w0","container":"container--axc64","list":"list--bnqgC","fadeSlideUp":"fadeSlideUp--A7PD8"};